import { useEffect } from "react";

export const useStyleSheet = (url: string) => {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = url;
    document.head.appendChild(link);

    return () => link.remove();
  }, [url]);
};
